import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    children: [
      {
        path: "/ath-games",
        component: Home,
      },
      {
        path: "/team",
        component: Home,
      },
    ],
  },
  {
    path: "/tokenomics",
    name: "tokenomics",
    component: () => import("../views/Tokenomics.vue"),
  },
  {
    path: "/android",
    name: "android",
    component: () => import("../views/HowToBuyAndroid.vue"),
  },
  {
    path: "/ios",
    name: "ios",
    component: () => import("../views/HowToBuyIOS.vue"),
  },
  {
    path: "/privacy-policy",
    name: "privacy-policy",
    component: () => import("../views/PrivacyPolicy.vue"),
  },
  {
    path: "/terms-of-service",
    name: "terms-of-service",
    component: () => import("../views/TermsOfService.vue"),
  },
];

const router = new VueRouter({
  scrollBehavior: function (to, from, savedPosition) {
    if (
      to.fullPath.includes("ath-games") ||
      to.fullPath.includes("team") ||
      to.fullPath.includes("6.2")
    ) {
      setTimeout(() => {
        let yOffset;
        if (window.innerWidth > 992) {
          yOffset = -(window.innerWidth * 0.07);
        } else {
          yOffset = -(window.innerWidth * 0.7);
        }
        const element = document.getElementById(
          to.fullPath.substring(to.fullPath.lastIndexOf("/") + 1)
        );
        const y =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        if (element && element.scrollIntoView) {
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }, 15);
      return { el: to.hash };
    } else if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
  routes,
});

export default router;
